import { render } from "./SocialBlock.vue?vue&type=template&id=48655a1c"
import script from "./SocialBlock.vue?vue&type=script&lang=js"
export * from "./SocialBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__